import { getPreviewTextLayerImages, getFinalTextLayerImages } from "./textLayer";

export default class AddToCartFlow {
  constructor(jsonSave, originalSpec, starMapSvg, edittoggle, textColor, revert) {
    this.jsonSave = jsonSave;
    this.originalSpec = originalSpec;
    this.starMapSvg = starMapSvg;
    this.edittoggle = edittoggle;
    this.textColor = textColor;
    this.revert = revert
  }

  beginAddToCartFlow() {
    const previewTextLayerPromise = this.getPreviewTextLayer();

    const finalTextLayerPromise = this.getFinalTextLayer(
      previewTextLayerPromise
    );
    const addToCartPromise = this.addToCart(previewTextLayerPromise);

    const uploadFinalTextLayerPromise = this.uploadFinalTextLayer(
      addToCartPromise,
      finalTextLayerPromise
    );

    return {
      addToCartPromise,
      uploadFinalTextLayerPromise,
    };
  }

  beginSendEmailFlow(email) {
    const previewTextLayerPromise = this.getPreviewTextLayer();

    const finalTextLayerPromise = this.getFinalTextLayer(
      previewTextLayerPromise
    );
    const addToCartPromise = this.addToCartAndSendEmail(previewTextLayerPromise, email);

    const uploadFinalTextLayerPromise = this.uploadFinalTextLayer(
      addToCartPromise,
      finalTextLayerPromise
    );

    return {
      addToCartPromise,
      uploadFinalTextLayerPromise,
    };
  }

  getPreviewTextLayer() {
    return new Promise((resolve, reject) => {
      try {
        if (!nse_config.image_settings.preview_text_layer_url) {
          resolve(null)
        } else {
          const previewTextLayerImages = getPreviewTextLayerImages(this.jsonSave, this.originalSpec, this.textColor);
          resolve(previewTextLayerImages);
        }
      } catch (err) {
        reject(err);
      }
    })
  }

  getFinalTextLayer() {
    return new Promise((resolve, reject) => {
      try {
        if (!nse_config.image_settings.preview_text_layer_url) {
          resolve(null)
        } else {
          const finalTextLayerImages = getFinalTextLayerImages(this.jsonSave, this.originalSpec, this.textColor);
          resolve(finalTextLayerImages);
        }
      } catch (err) {
        reject(err);
      }
    })
  }

  async addToCart(previewTextLayerPromise) {
    const textLayerImages = await previewTextLayerPromise;

    return fetch(window.nse_config.api_endpoint.add_to_cart, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": window.nse_config.nonce,
      },
      body: JSON.stringify(
        {
          selected: this.jsonSave,
          star_map_svg: encodeURIComponent(this.starMapSvg),
          text_layer_images: textLayerImages,
          revert: this.revert,
          product_id: window.nse_config.product_info.id,
          cart_item_key: nse_config.product_info.cart_item_key,
          quantity: nse_config.product_info.quantity,
          edittoggle: this.edittoggle,
          language: nse_config.language,
        },
        null,
        0
      ),
    }).then((response) => response.json());
  }

  async addToCartAndSendEmail(previewTextLayerPromise, email) {
    const textLayerImages = await previewTextLayerPromise;

    return fetch(window.nse_config.api_endpoint.send_to_email, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": window.nse_config.nonce,
      },
      body: JSON.stringify(
        {
          selected: this.jsonSave,
          star_map_svg: encodeURIComponent(this.starMapSvg),
          product_id: window.nse_config.product_info.id,
          text_layer_images: textLayerImages,
          revert: this.revert,
          send_to_email: 'yes',
				  email: email,
          cart_item_key: nse_config.product_info.cart_item_key,
          quantity: nse_config.product_info.quantity,
          edittoggle: this.edittoggle,
          language: nse_config.language,
        },
        null,
        0
      ),
    }).then((response) => response.json());
  }

  async uploadFinalTextLayer(addToCartPromise, finalTextLayerPromise) {
    if (!nse_config.image_settings.preview_text_layer_url) {
      return
    }
    const { cart_item_key } = await addToCartPromise;
    const finalTextLayerImages = await finalTextLayerPromise;
    let textLayerDpi = nse_config.image_settings.dpi_print_image

    if (this.jsonSave.product_finish === 'download') {
      textLayerDpi = nse_config.image_settings.dpi_download_image
    }

    const data = JSON.stringify({
      product_id: window.nse_config.product_info.id,
      cart_item_key: cart_item_key,
      text_layer_images: finalTextLayerImages,
      text_layer_dpi: textLayerDpi
    });
    // data.append("product_id", window.nse_config.product_info.id);
    // data.append("cart_item_key", cart_item_key);
    // data.append("text_layer_images", finalTextLayerImages);
    // data.append("text_layer_dpi", textLayerDpi)

    return await fetch(window.nse_config.api_endpoint.upload_final_text_layer, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-WP-Nonce": window.nse_config.nonce,
      },
      body: data,
    }).then((response) => response.json());
  }
}
